import React, { useMemo } from 'react'
import { BtRadioGroup } from '@linqpal/components/src/ui'

const SubcontractorShouldCarryBond = ({ model, value }) => {
  const radioButtons = useMemo(() => {
    const options = [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
    return (
      <BtRadioGroup
        value={value}
        onChange={(val) => model.setValue(val)}
        options={options}
        radioStyle={{ marginRight: 32 }}
        groupStyle={{ flexDirection: 'row' }}
        testID="subcontractor_should_carry_bond"
      />
    )
  }, [model, value])
  return radioButtons
}

export default {
  identifier: 'subcontractorShouldCarryBond',
  title: 'Were you required to carry a bond?',
  subtitle: 'As the sub-contractor*',
  component: SubcontractorShouldCarryBond,
}
